import { render } from "./PremiumPlacementEnableAccessComponent.vue?vue&type=template&id=07d3a54a"
import script from "./PremiumPlacementEnableAccessComponent.vue?vue&type=script&lang=js"
export * from "./PremiumPlacementEnableAccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__